require('./angular-touch');
module.exports = 'ngTouch';



//////////////////
// WEBPACK FOOTER
// ./~/angular-touch/index.js
// module id = 385
// module chunks = 3